import type { SVGProps } from 'react';

const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 5" {...props}>
    <path fill={props.color} d="M.88 0 4.5 3.101 8.12 0 9 .914 4.5 5 0 .914z" />
  </svg>
);

export default SvgChevronDown;
